module.exports = __webpack_public_path__ + "img/restaurant.f757b92e.png";